import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=67829f65&scoped=true"
import script from "./GoodsCard.vue?vue&type=script&lang=ts"
export * from "./GoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=67829f65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67829f65",
  null
  
)

export default component.exports